<script setup lang="ts">
import { config } from '#core/config/env';
import type { UserType } from '#root/domain/user/user.schema';
import { DropdownItem, DropdownMenu } from '#webui/components';
import { useLanguage } from '#webui/components/composables/useLanguage';
import type { IconNameType } from '@c4-links/vue3-links-components';
import { computed, type ComputedRef, type PropType } from 'vue';
import VueFeather from 'vue-feather';
import { type RouteLocationRaw } from 'vue-router';

const { t } = useLanguage();

defineProps({
  user: { type: Object as PropType<UserType>, required: true }
});

const userNavigation: ComputedRef<
  {
    name: string;
    icon?: IconNameType;
    onclick?: () => void;
    link?: RouteLocationRaw;
  }[]
> = computed(() => [
  {
    name: t('inno_topbar.logout_button'),
    icon: 'log-out',
    onclick: () => {
      window.location.href = `${config.apiBaseUrl}/logout`;
    }
  }
]);
</script>

<template>
  <DropdownMenu as="div" position="left">
    <img v-if="user.photoUrl" class="h-8 w-8 rounded-full bg-gray-50" :src="user.photoUrl" alt="" />
    <VueFeather
      v-if="!user.photoUrl"
      size="20"
      stroke-width="2"
      type="user"
      class="rounded-full bg-gray-50"
      aria-hidden="true"
    />

    <span class="flex items-center">
      <span class="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">{{ user.fullName }}</span>
    </span>
    <template #items>
      <DropdownItem
        v-for="item in userNavigation"
        :key="item.name"
        v-slot="{ active }"
        :icon="item.icon"
        :link="item.link"
        @click="item.onclick"
      >
        <span :class="[active ? 'bg-gray-50' : '', 'text-sm leading-6 text-gray-900']">
          {{ item.name }}
        </span>
      </DropdownItem></template
    >
  </DropdownMenu>
</template>
